import { AxiosResponse } from 'axios'
import { ServiceDependencies } from 'lib/core/services/magento'
import { axiosClient } from 'lib/core/services/magento/client'
import { jsonToGraphQLQuery } from 'lib/core/resources/helpers/jsonToGraphql'

export interface CmsBlocksQueryObject {
  cmsBlocks: {
    __args: {
      identifiers: string | string[]
    }
    items: {
      identifier: boolean
      title: boolean
      content: boolean
      [key: string]: any
    }
  }
}

export const cmsBlocksQueryObject = {
  cmsBlocks: {
    __args: {
      identifiers: '%{id}'
    },
    items: {
      identifier: true,
      title: true,
      content: true
    }
  }
}

interface CmsBlockQueryInput {
  id: string | string[]
}

export type GetCmsBlockQuery = (input: CmsBlockQueryInput) => Promise<AxiosResponse<any>>

export const createCmsBlocksQuery = ({ getQueries }: ServiceDependencies): GetCmsBlockQuery => async (input) => {
  const query = getQueries().cmsBlocksQuery
  query.cmsBlocks.__args.identifiers = input.id

  return axiosClient(jsonToGraphQLQuery(query), true)
}
